import { Col, DatePicker, Form } from 'antd'
import { Rule } from 'antd/es/form'
import dayjs from 'dayjs'

import { TFieldProps } from '..'
import './styles.scss'

import 'dayjs/locale/es'

dayjs.locale('es')

export default function DateTimeFormField({ fieldInfo }: TFieldProps) {
  const setFieldRules = (): Rule[] => {
    const rules: Rule[] = []

    if (fieldInfo.required) {
      rules.push({
        required: true,
        message: 'Este campo es obligatorio',
      })
    }

    return rules
  }
  return (
    <Col
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-end',
      }}
      xxl={4}
      xl={6}
      md={8}
      sm={12}
      xs={24}
    >
      <Form.Item
        className={`date-time-field ${fieldInfo.className ?? ''}`}
        label={fieldInfo.label}
        name={fieldInfo.name}
        required={fieldInfo.required}
        tooltip={fieldInfo.description}
        rules={setFieldRules()}
      >
        <DatePicker format={'DD/MM/YYYY HH:mm'} size='small' showTime />
      </Form.Item>
    </Col>
  )
}
